import { Button } from '@/components'
import { RewardButtonWithState } from '@/components/molecules/rewards/RewardButton'
import React from 'react'
import { useTranslation } from 'react-i18next'
import type { PresentTypeBasedComponentsProps } from './presentTypeComponentType'

/**
 * PresentType 軸の/rewards/detail ページで使用されるコンポーネント
 * */
export const PresentType02ProductComponents = ({
  selectedType,
  presentType,
  checkCondition,
  isStock,
  inPeriod,
  onStartDownload,
  onStartDownloadOnly,
  onStartDownloadWithLottery,
  onGoDirectToConfirm,
  onDecideUserPresentItem,
  multiple,
  buttonDisabled = false,
  isApplicationForm,
  isApplicationAnswered,
  userRewardState,
  presentItemList,
}: PresentTypeBasedComponentsProps) => {
  const { t } = useTranslation()
  if (presentType !== 'Product') {
    return null
  }
  if (!isStock) {
    // - 特典リストを出す場合: すぐに「終了しました」を出す
    // - 特典リストを出さない場合: 特典を獲得していないければ、「終了しました」を出す。
    const skipSpecificCondition1 = selectedType === 3 && userRewardState === 'RECEIVED'
    const skipSpecificCondition2 = selectedType === 1 && userRewardState === 'RECEIVED'
    if ((skipSpecificCondition1 || skipSpecificCondition2) && !presentItemList) {
      // skip: すぐに「終了しました」を出さない場合
    } else {
      return (
        <RewardButtonWithState
          inPeriod={inPeriod}
          isStock={isStock}
          checkCondition={checkCondition}
          selectedType={selectedType}
          presentType={presentType}
          isApplicationForm={isApplicationForm}
        />
      )
    }
  }

  if (!inPeriod) {
    return (
      <RewardButtonWithState
        inPeriod={inPeriod}
        isStock={isStock}
        checkCondition={checkCondition}
        selectedType={selectedType}
        presentType={presentType}
        isApplicationForm={isApplicationForm}
      />
    )
  }
  return (
    <>
      {selectedType === 1 && (
        <>
          {isApplicationForm !== 0 ? (
            <>
              <Button
                text={
                  !isApplicationAnswered
                    ? t('reward_detail.apply', '応募する')
                    : userRewardState === 'CONDITION_MET' ||
                        userRewardState === 'CONDITION_NOT_MET' ||
                        userRewardState === 'RECEIVED'
                      ? t('reward_detail.apply', '応募する')
                      : t('reward_detail.already_applied', '応募済み')
                }
                width="w-9/12"
                onClick={() => {
                  if (userRewardState === 'RECEIVED') {
                    onGoDirectToConfirm({})
                  } else {
                    if (userRewardState === 'CONDITION_MET') {
                      onDecideUserPresentItem().then((userPresentId) => onGoDirectToConfirm({ userPresentId }))
                    }
                  }
                }}
                disabled={buttonDisabled || (userRewardState !== 'RECEIVED' && !checkCondition)}
              />
            </>
          ) : (
            <>
              {presentItemList ? (
                <>
                  <Button
                    text={
                      multiple
                        ? t('reward_detail.receive_your_prize_2', '賞品を受け取る')
                        : userRewardState === 'CONDITION_MET' ||
                            userRewardState === 'CONDITION_NOT_MET' ||
                            userRewardState === 'RECEIVED'
                          ? t('reward_detail.receive_your_prize_2', '賞品を受け取る')
                          : t('reward_detail.prize_have_received', '賞品受け取り済み')
                    }
                    width="w-9/12"
                    onClick={onStartDownload}
                    disabled={buttonDisabled || !checkCondition}
                  />
                </>
              ) : (
                <>
                  <Button
                    text={
                      userRewardState === 'CONDITION_MET' ||
                      userRewardState === 'CONDITION_NOT_MET' ||
                      userRewardState === 'RECEIVED'
                        ? t('reward_detail.receive_your_prize_2', '賞品を受け取る')
                        : t('reward_detail.prize_have_received', '賞品受け取り済み')
                    }
                    width="w-9/12"
                    onClick={() => {
                      if (userRewardState === 'CONDITION_MET') {
                        onDecideUserPresentItem().then((userPresentId) => onGoDirectToConfirm({ userPresentId }))
                      } else {
                        onGoDirectToConfirm({})
                      }
                    }}
                    disabled={buttonDisabled || (userRewardState !== 'RECEIVED' && !checkCondition)}
                  />
                </>
              )}
            </>
          )}
        </>
      )}
      {selectedType === 2 && (
        <>
          <Button text={'存在しないパターン'} width="w-9/12" onClick={() => {}} disabled={true} />
        </>
      )}
      {selectedType === 3 && (
        <>
          {isApplicationForm !== 0 ? (
            <>
              {presentItemList ? (
                <>
                  <Button
                    text={
                      userRewardState === 'CONDITION_MET' || userRewardState === 'CONDITION_NOT_MET'
                        ? t('reward_detail.lottery', '抽選する')
                        : userRewardState === 'RECEIVED'
                          ? t('reward_detail.apply', '応募する')
                          : t('reward_detail.already_applied', '応募済み')
                    }
                    width="w-9/12"
                    onClick={() => {
                      if (userRewardState === 'CONDITION_MET') {
                        onStartDownloadWithLottery()
                      } else if (userRewardState === 'RECEIVED') {
                        onGoDirectToConfirm({})
                      }
                    }}
                    disabled={buttonDisabled || !checkCondition}
                  />
                </>
              ) : (
                <>
                  <Button
                    text={
                      userRewardState === 'CONDITION_MET' || userRewardState === 'CONDITION_NOT_MET'
                        ? t('reward_detail.lottery', '抽選する')
                        : userRewardState === 'RECEIVED'
                          ? t('reward_detail.apply', '応募する')
                          : t('reward_detail.already_applied', '応募済み')
                    }
                    width="w-9/12"
                    onClick={() => {
                      if (userRewardState === 'CONDITION_MET') {
                        onStartDownloadWithLottery()
                      } else if (userRewardState === 'RECEIVED') {
                        onGoDirectToConfirm({})
                      }
                    }}
                    disabled={buttonDisabled || (userRewardState !== 'RECEIVED' && !checkCondition)}
                  />
                </>
              )}
            </>
          ) : (
            <>
              {presentItemList ? (
                <>
                  <Button
                    text={
                      multiple
                        ? t('reward_detail.lottery', '抽選する')
                        : userRewardState === 'CONDITION_MET' || userRewardState === 'CONDITION_NOT_MET'
                          ? t('reward_detail.lottery', '抽選する')
                          : userRewardState === 'RECEIVED'
                            ? t('reward_detail.receive_your_prize_2', '賞品を受け取る')
                            : t('reward_detail.prize_have_received', '賞品受け取り済み')
                    }
                    width="w-9/12"
                    onClick={userRewardState === 'RECEIVED' ? onStartDownloadOnly : onStartDownloadWithLottery}
                    disabled={buttonDisabled || !checkCondition}
                  />
                </>
              ) : (
                <>
                  <Button
                    text={
                      userRewardState === 'CONDITION_MET' || userRewardState === 'CONDITION_NOT_MET'
                        ? t('reward_detail.lottery', '抽選する')
                        : userRewardState === 'RECEIVED'
                          ? t('reward_detail.receive_your_prize_2', '賞品を受け取る')
                          : userRewardState === 'EXCHANGED'
                            ? t('reward_detail.prize_have_received', '賞品受け取り済み')
                            : ''
                    }
                    width={'w-9/12'}
                    onClick={() => {
                      if (userRewardState === 'RECEIVED') {
                        onGoDirectToConfirm({})
                      } else {
                        onStartDownloadWithLottery()
                      }
                    }}
                    disabled={buttonDisabled || (userRewardState !== 'RECEIVED' && !checkCondition)}
                  />
                </>
              )}
            </>
          )}
        </>
      )}
    </>
  )
}
